import { Environment } from '../app/models/environment.model';

export const environment: Environment = {
  production: false,
  apiBaseUrl: '/api',
  appName: 'IDAP Connector Studio'
};
